import { message } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import StoryTimeDeleteModal from "./components/storyTimeDeleteModal";
import { createMainColumns, createSubColumns } from "./content/storyTimeColumns";
import type { StoryTimeListType, StoryTimeGroupType } from "./content/storyTimeType"
import { header } from "../utils/zippyAdminHeader";
import TableCustom from "../../../components/ui/TableCustom";
import { apiCall } from "../../../utils/apiCall";

export default function StoryTimeList({
  data,
  setModalAction,
  setOpenMainModal,
  setEditMainData,
  refresh,
}: {
  data: StoryTimeListType[];
  setModalAction: any;
  setOpenMainModal: any;
  setEditMainData: any;
  refresh: any;
}) {
  const [expandedRowKeys, setExpandedRowKeys] = useState<React.Key[]>([]);
  const [showMainDeleteModal, setShowMainDeleteModal] = useState(false);
  const [mainDeleteData, setMainDeleteData] = useState<StoryTimeListType | undefined>();
  const navigate = useNavigate();

  const handleExpand = (expanded: boolean, record: StoryTimeListType) => {
    setExpandedRowKeys(prev =>
      expanded
        ? [...prev, record.storyId]
        : prev.filter(key => key !== record.storyId)
    );
  };

  const closeMainDeleteModal = () => {
    setShowMainDeleteModal(false);
    setMainDeleteData(undefined);
  }

  const handleMainEditClick = (record: StoryTimeListType) => {
    setModalAction("Edit");
    setOpenMainModal(true);
    setEditMainData(record);
  };

  const handleMainDeleteClick = (record: StoryTimeListType) => {
    setShowMainDeleteModal(true);
    setMainDeleteData(record);
  };

  const handleMainDelete = async () => {
    try {
      const data = await apiCall({
        method: "DELETE",
        header: header,
        endPoint:
          process.env.REACT_APP_ZIPPY_ADMIN +
          "/stories/admin/" +
          mainDeleteData!.storyId,
      });

      if (data && data.status) {
        message.success(data.status);
        refresh();
      } else {
        message.error(data.response.data.status);
      }
    } catch (e) {
      console.log(e);
    }

    closeMainDeleteModal();
  };

  const handleSubEdit = (record: StoryTimeGroupType) => {
    navigate(`/zippy-and-me/story-time/${record.storyGroupId}/detail`);
  };

  return (
    <>
      <TableCustom
        className="custom-table-style"
        dataSource={data}
        columns={createMainColumns(handleMainEditClick, handleMainDeleteClick)}
        pagination={false}
        rowKey="storyId"
        expandable={{
          expandedRowKeys,
          onExpand: handleExpand,
          expandedRowRender: (record) => (
            <TableCustom
              columns={createSubColumns(handleSubEdit)}
              dataSource={record.groups}
              rowKey="storyGroupId"
              pagination={false}
            />
          ),
          rowExpandable: (record) => record.groups && record.groups.length > 0,
        }}
      />
      <StoryTimeDeleteModal
        open={showMainDeleteModal}
        close={closeMainDeleteModal}
        handleDelete={() => handleMainDelete()}
      />
    </>
  );
}
